// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"8bcbdb1c","550":"efde24ff","697":"bc61a081","787":"bb86e386"}[chunkId] + ".chunk.js";
};